// extracted by mini-css-extract-plugin
module.exports = {"container":"cart-sidebar_container__9A6w7","isOpen":"cart-sidebar_isOpen__8NwgE"};